var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kerryThBarcode"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.data.barcode)}}),(_vm.subType)?_c('span',[_vm._v(_vm._s(_vm.$t(("shipping.kerry_th." + _vm.subType))))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }